var PowerstreamV2 = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this.currentStep = 1;
    this.bundles = [];
    this.currentIndex = 0;
  }
  async connectedCallback() {
    this.selectors = {
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      savings: '[data-savings]'
    }

    this.container = this.querySelector(".product-container");
    this.priceContainer = this.container.querySelector(this.selectors.priceContainer);


    this.currencySymbol = this.dataset.currencySymbol;
    this.savePerYear = this.container.querySelector("#save-per-year");
    this.capacity = this.container.querySelector("#capacity");
    this.electricityGenerated = this.container.querySelector("#electricity-generated");

    var productJson = this.container.querySelector('#product-json');
    if (!productJson || !productJson.innerHTML.length) {
      return;
    }

    this.product = JSON.parse(productJson.innerHTML);

    this.productState = {
        available: true,
        soldOut: false,
        onSale: false,
        showUnitPrice: false
      };

      // "monthElectricPriceBefore": 100,
      // "avgElectricPrice": 4,
    this.chooseForm = {   
      "longitude": "",
      "latitude": "", 
      "country": "",
      "address": "",
      "website": "de",
      "familyStructure": 1,
      "daytimeElectrPercentage": 50,
      "unit": "$",
      "bizType": 0,
      "electricityPricePercentage": "35", 
      "solarPanelsPlace": [1]
   }
    this._init();
    this._initFormContent();
    this.updateCurrentVariant();
    this._initGallery();
    this._initTabButtons();
    this._initVariantButtons();
    this._klarna();
    this._initGoogleMaps();
    this._initSteps();
    this._initCustomSelect();
    this._initUsageSlider();
    this._initPlanTabs();
    this.renderBundle(0);

    // update bundle id 

    const hash = window.location.hash;
   if(hash){
     const bundleItem = this.container.querySelector(".variant-buttons [data-variant-id='"+hash.substring(1)+"']")
     if(bundleItem){
       bundleItem.click();
     }
   }
  }
  _init(){
    const target = this.container.querySelector('.compare-button');
    const buybutton = this.container.querySelector('.buy-now-container');
    const bundletarget = this.container.querySelector('.plan-actions');
    const bundlebuybutton = this.container.querySelector('.bundle-buy-container');
    const tab_contents = this.container.querySelector(".product-tab-contents")
  
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          buybutton.classList.remove("fixed");
        } else {
          buybutton.classList.add("fixed");
          buybutton.style.setProperty("--fixed-width", tab_contents.clientWidth+"px");
        }
      });
    }, {
      root: null, 
      threshold: 1
    });
  
    observer.observe(target);

    if(bundlebuybutton){

      const observer1 = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            bundlebuybutton.classList.remove("fixed");
          } else {
            bundlebuybutton.classList.add("fixed");
            bundlebuybutton.style.setProperty("--fixed-width", tab_contents.clientWidth+"px");
          }
        });
      }, {
        root: null, 
        threshold: 1
      });
    
      observer1.observe(bundletarget);
    }
  }
  disconnectedCallback() {}

  updateCurrentVariant(){
    const variant_id = this.container.querySelector(".variant-buttons .variant-button__item.open").dataset.variantId
    this.product.variants.forEach(item => {
        if(item.id == variant_id){
            this.currentVariant = item
        }
    })

    var variant = this.currentVariant;

    if (!variant) {
     this.productState.available = false;
     return;
    }

    // const optionLabelIncluded = this.container.querySelector('.buy-now-container [data-tax-included]')
    // const optionLabelExcluded = this.container.querySelector('.buy-now-container [data-tax-excluded]')
    // if(variant.title.replace(/\s/g, '').includes("0%")){
    //   optionLabelIncluded.classList.add('hide')
    //   optionLabelExcluded.classList.remove('hide')
    // }else{
    //   optionLabelIncluded.classList.remove('hide')
    //   optionLabelExcluded.classList.add('hide')
    // }


    const buybutton = this.container.querySelector(".buy-now__button [data-variant-id]");

    buybutton.dataset.variantId = variant.id

    this.productState.available = true;
    this.productState.soldOut = !variant.available;
    this.productState.onSale = variant.compare_at_price > variant.price;
    this.productState.showUnitPrice = !!variant.unit_price;
    

    this._updateImages();
    this._updatePrice();
  }

  _klarna() {
    const klarnas = this.container.querySelectorAll(".product-klarna .info");
    klarnas.forEach(klarna => {
      klarna.addEventListener("click", (e) => {
          const klarnaEle = klarna.nextElementSibling;
          if(klarnaEle && klarnaEle.shadowRoot){
              klarnaEle.shadowRoot.querySelector("button").click()
          }
      });
    })
  }
  _initVariantButtons(){


    const variantButtons = this.container.querySelectorAll(".variant-buttons .variant-button__item");
    variantButtons.forEach(variantBtn => {
        variantBtn.addEventListener("click", (e) => {
            this.container.querySelector(".variant-buttons .variant-button__item.open").classList.remove("open")
            variantBtn.classList.add("open");

            this.container.querySelector("#save-per-year").innerHTML = variantBtn.dataset.savePerYear 
            this.container.querySelector("#capacity").innerHTML = variantBtn.dataset.capacity 
            this.container.querySelector("#electricity-generated").innerHTML = variantBtn.dataset.electricityGenerated 

            this.updateCurrentVariant();
        });
    })
  }

  _updatePrice(){
    var variant = this.currentVariant


    var priceFormat = theme.priceCurrencyCodeEnable ? theme.moneyFormatWithCurrency : theme.moneyFormat;
    var comparePriceFormat = theme.comparePriceCurrencyCodeEnable ? theme.moneyFormatWithCurrency : theme.moneyFormat;
    var formatRegularPrice = function(regularPriceElement, price) {
      regularPriceElement.innerHTML = theme.Currency.formatMoney(
        price,
        comparePriceFormat
      ).replace(/\./g, ' ');
    };

    this.container.getElementsByTagName("klarna-placement")[0].setAttribute("data-purchase-amount", variant.price);
    if(window.Klarna && window.Klarna.OnsiteMessaging){
      window.Klarna.OnsiteMessaging.refresh();
    }

  

    var regularPrices = this.priceContainer.querySelectorAll(
        this.selectors.regularPrice
    );
    var salePrice = this.priceContainer.querySelector(
        this.selectors.salePrice
    );
    var savings = this.priceContainer.querySelector(
         this.selectors.savings
    );
    var unitPrice = this.priceContainer.querySelector(
        this.selectors.unitPrice
    );

    let current_price = variant.price; 

    if (this.productState.onSale) {
        this.priceContainer.classList.add("price--on-sale");
        regularPrices.forEach(function(regularPrice) {
          formatRegularPrice(regularPrice, variant.compare_at_price);
        });
        salePrice.innerHTML = theme.Currency.formatMoney(
          variant.price,
          priceFormat
        ).replace(/\./g, ' ');
        savings.innerHTML = '-' + theme.Currency.formatMoney(
          variant.compare_at_price - variant.price,
          theme.moneyFormat
        ).replace(',00', '').replace(/\./g, ' ');

    } else {
        this.priceContainer.classList.remove("price--on-sale");
        regularPrices.forEach(function(regularPrice) {
            formatRegularPrice(regularPrice, variant.price);
        });
    }


    const klarnaEle = this.container.querySelector(".buy-now-container .product-klarna");


    if(klarnaEle && klarnaEle.dataset.info){
        klarnaEle.querySelector(".info").innerHTML = klarnaEle.dataset.info.replace("\${price}",theme.Currency.formatMoney(
        current_price/3.0,
        comparePriceFormat
      ).replace(/\./g, ' '));
    }
  }


  _updateImages(){
    var variant = this.currentVariant

    var slider = this.container.querySelector('[data-product-main-slider]');
    var featuredMediaIndex = 0;
    var variantMedia = variant.featured_media;
    if(variantMedia) {
        var variantMediaId = variant.featured_media.id;
        var featuredMedia = slider.querySelector('.image_type[data-image-id="'+variantMediaId+'"]');
        if(featuredMedia) {
        var featuredMediaParent = featuredMedia.closest('.product-single__media__slide');
        if(featuredMediaParent) {
            featuredMediaIndex = [].slice.call(featuredMediaParent.parentNode.children).indexOf(featuredMediaParent);

            if(this.flickityInstance) {
            this.flickityInstance.selectCell(featuredMediaIndex);
            }
        }

        }
    }
  }
  _initTabButtons(){
    const tabButtons = this.container.querySelector(".product-tab-buttons");
    tabButtons.addEventListener("click", (e) => {
        const btn = e.target.closest(".button");
        if (!btn) return;
        
        e.stopPropagation();
        this.container.querySelector(".product-tab-buttons .button.active").classList.remove("active");
        btn.classList.add("active");

        if (btn.id === 'help-me-choose') {
           this._resetSteps();
            this.savePerYear.innerHTML = this.savePerYear.innerHTML.replace(/(?:\d+[\s,]*)+/g, '0 ');
            this.capacity.innerHTML = this.capacity.innerHTML.replace(/(?:\d+[\s,]*)+/g, '0 ');
            this.electricityGenerated.innerHTML = this.electricityGenerated.innerHTML.replace(/(?:\d+[\s,]*)+/g, '0 ');
        } else if (btn.id === 'stream-bundles') {
            const openBtn = this.container.querySelector(".variant-buttons .variant-button__item.open");
            if (openBtn) {
                this.container.querySelector("#save-per-year").innerHTML = openBtn.dataset.savePerYear;
                this.container.querySelector("#capacity").innerHTML = openBtn.dataset.capacity;
                this.container.querySelector("#electricity-generated").innerHTML = openBtn.dataset.electricityGenerated;
            }
            // 显示主图，隐藏 bundle gallery
            const mainGallery = this.container.querySelector('.product-single__media__carousel');
            const bundleGallery = this.container.querySelector('.bundle-gallery');
            const thumbnails = this.container.querySelector('.thumbnails-grid');
            if (mainGallery) mainGallery.style.display = 'block';
            if (bundleGallery) bundleGallery.style.display = 'none';
            if (thumbnails) thumbnails.style.display = '';
        }
    });
  }
  _resetSteps(){
     // Reset to first step when switching tabs
     this.currentStep = 1;
            
     // Reset chooseForm to initial values
    
       // "monthElectricPriceBefore": 100,
       // "avgElectricPrice": 4,
     this.chooseForm = {   
       "longitude": "",
       "latitude": "", 
       "country": "",
       "address": "",
       "website": "de",
       "familyStructure": 1,
       "daytimeElectrPercentage": 50,
       "unit": "$",
       "bizType": 0,
       "electricityPricePercentage": "35", 
       "solarPanelsPlace": [1]
     };

     // Reset steps UI
     const steps = this.container.querySelectorAll('.step');
     steps.forEach(step => {
         if (step.dataset.step === '1') {
             step.classList.add('active', 'current');
         } else {
             step.classList.remove('active', 'current');
         }
     });

     // Hide all step contents and show only step 1
     const stepContents = this.container.querySelectorAll('.step-content > div');
     stepContents.forEach(content => {
         if (content.classList.contains('step-1')) {
             content.style.display = 'block';
         } else {
             content.style.display = 'none';
         }
     });

     // Reset step 3 status box
     const statusBox = this.container.querySelector('.step-3-status');
     if (statusBox) {
         statusBox.style.display = 'none'; // Clear status box content
     }

     // Reset form content to initial values
     this._initFormContent();
  }
  _initGallery(startIndex) {
    var main_slider = this.container.querySelector(
      ".product-single__media__carousel"
    );
    var thumbnails_grid = this.container.querySelector('.thumbnails-grid');
    var main_slider_options = JSON.parse(
      main_slider.getAttribute("data-flickity-config")
    );
    var product_image__zoom = this.container.querySelector(
      ".product_image__zoom"
    );
    if (main_slider) {
      if (startIndex) {
        main_slider_options.initialIndex = startIndex;
      }

      this.flickityInstance = new Flickity(main_slider, main_slider_options);
      this.flickityInstance.element.classList.add("rendered");

      var slider = this.container.querySelector("[data-product-main-slider]");

      var flkty = Flickity.data(slider);

      document.querySelector(".product__media__arrows .btn-previous").onclick =
        function () {
          flkty.previous();
        };
      document.querySelector(".product__media__arrows .btn-next").onclick =
        function () {
          flkty.next();
        };
      this.flickityInstance.on("select",  (index) => {
        var flickity_slider = this.flickityInstance.element;
      
        var selectedSlide = this.flickityInstance.selectedElement;

        document
          .querySelectorAll(".product-single__thumbnails-block")
          .forEach(function (elem) {
            elem.classList.remove("selected");
          });

        const selectedThumb = document.querySelector(
          '.product-single__thumbnails-block[data-thumb-index="' +
            selectedSlide.getAttribute("data-media-index") +
            '"]'
        );
        if (selectedThumb) {
          selectedThumb.classList.add("selected");
        } else {
          console.error(
            "Element not found for data-thumb-index:",
            selectedSlide.getAttribute("data-media-index")
          );
        }
      });
    }

    if (product_image__zoom) {
      var imagesArr = main_slider.querySelectorAll(".image_type");
      if (imagesArr.length) {
        imagesArr.forEach(function (item, index) {
          item.addEventListener("click", function (e) {
            e.preventDefault();

            var pswpElement = document.querySelectorAll(".pswp")[0];

            var items = [];
            var thumbnails = "";
            imagesArr.forEach(function (imageEl, index) {
              var imageObj = {
                src: imageEl.getAttribute("data-image-url"),
                w: +imageEl.getAttribute("data-image-width"),
                h: +imageEl.getAttribute("data-image-height"),
              };
              items.push(imageObj);
              thumbnails +=
                '<div class="product_thumbnail"><img src="' +
                imageEl.getAttribute("data-image-url") +
                '" /></div>';
            });

            var options = {
              index: item.getAttribute("data-media-index"),
              zoomEl: false,
              shareEl: false,
              fullscreenEl: false,
              counterEl: false,
              closeOnScroll: false,
              closeOnVerticalDrag: false,
            };

            var gallery = new PhotoSwipe(
              pswpElement,
              PhotoSwipeUI_Default,
              items,
              options
            );
            gallery.init();

            gallery.listen("afterChange", function (index) {
              document
                .querySelector(
                  ".photoSwipe_innerthumbs .product_thumbnail.selected"
                )
                .classList.remove("selected");
              document
                .querySelectorAll(".photoSwipe_innerthumbs .product_thumbnail")
                [gallery.getCurrentIndex()].classList.add("selected");
            });

            if (thumbnails != "") {
              document.querySelector("div.photoSwipe_innerthumbs").innerHTML =
                thumbnails;
              document
                .querySelectorAll(
                  "div.photoSwipe_innerthumbs .product_thumbnail"
                )
                [gallery.getCurrentIndex()].classList.add("selected");

              document
                .querySelectorAll(
                  "div.photoSwipe_innerthumbs .product_thumbnail"
                )
                .forEach(function (thumb, index) {
                  thumb.onclick = function () {
                    document
                      .querySelector(
                        "div.photoSwipe_innerthumbs .product_thumbnail.selected"
                      )
                      .classList.remove("selected");
                    thumb.classList.add("selected");
                    gallery.goTo(index);
                  };
                });
              document
                .querySelector(".pswp__button--close")
                .addEventListener("click", function (e) {
                  gallery.destroy();
                });
            }
          });
        });
      }
    }

    if(thumbnails_grid) {
        var thumbnail_images = thumbnails_grid.querySelectorAll('.product-single__thumbnails-block');
        if(thumbnail_images.length) {
          thumbnail_images.forEach( (thumb,index) => {
            thumb.addEventListener('click', (e) => {
              e.preventDefault();
              thumbnails_grid.querySelector('.product-single__thumbnails-block.selected').classList.remove('selected');
              thumb.classList.add('selected');
              this.flickityInstance.select(index);
              document.dispatchEvent(
                new CustomEvent('imageChange', {
                  detail: {},
                  bubbles: true,
                  cancelable: true
                })
              );
            });
          });
        }
      }
  }

  _initGoogleMaps() {
    // 优先用默认坐标初始化地图
    this.currentLocation = { lat: 52.5200, lng: 13.4050 };
    this._initializeMap();

    // 再尝试定位，定位成功后 setCenter
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.currentLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          if (this.map) {
            this.map.setCenter(this.currentLocation);
          }
          this._setupFullscreenControls(document.querySelector('.full-icon'));
        },
        (error) => {
          // 定位失败，地图已初始化为默认
          this._setupFullscreenControls(document.querySelector('.full-icon'));
        },
        { timeout: 3000 }
      );
    } else {
      // 不支持定位，地图已初始化为默认
      this._setupFullscreenControls(document.querySelector('.full-icon'));
    }
  }

  _setupFullscreenControls(fullIcon) {
    if (fullIcon) {
        // Add fullscreen control to map in normal mode
        const fullscreenControlDiv = document.createElement('div');
        const normalModeIcon = fullIcon.cloneNode(true);
        fullscreenControlDiv.appendChild(normalModeIcon);
        this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(fullscreenControlDiv);

        // Add click event to both icons
        [fullIcon, normalModeIcon].forEach(icon => {
            icon.addEventListener('click', () => {
                const mapElement = document.getElementById('map');
                if (!document.fullscreenElement) {
                    mapElement.requestFullscreen();
                } else {
                    document.exitFullscreen();
                }
            });
        });

        // Handle fullscreen changes
        document.addEventListener('fullscreenchange', () => {
            const isFullscreen = !!document.fullscreenElement;
            const mapContainer = document.querySelector('.map-container');
            
            if (isFullscreen) {
                mapContainer.classList.add('fullscreen');
            } else {
                mapContainer.classList.remove('fullscreen');
            }
        });
    }
  }

  _initializeMap() {
    if (!this.map) {
        const mapElement = document.getElementById('map');
        const addressInput = document.getElementById('address-input');
        
        this.map = new google.maps.Map(mapElement, {
            center: this.currentLocation,
            zoom: 15,
            mapTypeControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            zoomControl: true,
            gestureHandling: 'greedy',
            disableDefaultUI: true
        });

        // Add marker at current location
        const marker = new google.maps.Marker({
            position: this.currentLocation,
            map: this.map,
            title: 'Your Location',
            draggable: true
        });

        // Add click listener to map
        this.map.addListener('click', (event) => {
            const clickedLocation = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
            };
            
            // Update marker position
            marker.setPosition(clickedLocation);
            
            // Get address from coordinates
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: clickedLocation }, (results, status) => {
                if (status === 'OK' && results[0]) {
                    addressInput.value = results[0].formatted_address;
                    // Enable next button if address is selected
                    const nextBtn = document.querySelector('.step-1 .next-btn');
                    if (nextBtn) {
                        nextBtn.disabled = false;
                    }
                }
            });
        });

        // Add dragend listener to marker
        marker.addListener('dragend', (event) => {
            const draggedLocation = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
            };
            
            // Get address from coordinates
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({ location: draggedLocation }, (results, status) => {
                if (status === 'OK' && results[0]) {
                    addressInput.value = results[0].formatted_address;
                    // Enable next button if address is selected
                    const nextBtn = document.querySelector('.step-1 .next-btn');
                    if (nextBtn) {
                        nextBtn.disabled = false;
                    }
                }
            });
        });

        // Initialize address search
        this._initAddressSearch();
    }
  }

  _initAddressSearch() {
    const input = this.container.querySelector('#address-input');
    const suggestionsContainer = this.container.querySelector('.address-suggestions');
    const suggestionsList = this.container.querySelector('.suggestions-list');
    const searchService = new google.maps.places.AutocompleteService();
    const placesService = new google.maps.places.PlacesService(this.map);

    // Handle input changes
    let timeout = null;
    input.addEventListener('input', (e) => {
      clearTimeout(timeout);
      const query = e.target.value;
      
      if (query.length < 2) {
        suggestionsContainer.style.display = 'none';
        return;
      }

      timeout = setTimeout(() => {
        searchService.getPlacePredictions({
          input: query,
          types: ['address']
        }, (predictions, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK) {
            suggestionsContainer.style.display = 'none';
            return;
          }

          suggestionsList.innerHTML = '';
          predictions.forEach(prediction => {
            const item = document.createElement('div');
            item.className = 'suggestion-item';
            item.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16 7.20312C16 5.54627 15.4142 4.13205 14.2426 2.96048C13.0711 1.78891 11.6569 1.20312 10 1.20312C8.34315 1.20312 6.92893 1.78891 5.75736 2.96048C4.58579 4.13205 4 5.54627 4 7.20312C4 9.10375 4.94351 11.05 6.83054 13.0418C7.74429 14.0064 8.6621 14.7959 9.58397 15.4105C9.64558 15.4516 9.71181 15.4829 9.78266 15.5043C9.85352 15.5257 9.92597 15.5364 10 15.5364C10.074 15.5364 10.1465 15.5257 10.2173 15.5043C10.2882 15.4829 10.3544 15.4516 10.416 15.4105C11.3379 14.7959 12.2557 14.0064 13.1695 13.0418C15.0565 11.05 16 9.10375 16 7.20312ZM10 2.70312C11.2427 2.70312 12.3033 3.14247 13.182 4.02115C14.0607 4.89983 14.5 5.96048 14.5 7.20312C14.5 8.70528 13.6935 10.3076 12.0805 12.0102C11.3842 12.7452 10.6907 13.3656 10 13.8714C9.30931 13.3656 8.61579 12.7452 7.91946 12.0102C6.30649 10.3076 5.5 8.70528 5.5 7.20312C5.5 5.96048 5.93934 4.89983 6.81802 4.02115C7.6967 3.14247 8.75736 2.70312 10 2.70312ZM11.7678 5.43535C11.2796 4.9472 10.6904 4.70312 10 4.70312C9.30965 4.70312 8.72039 4.9472 8.23223 5.43535C7.74408 5.92351 7.5 6.51277 7.5 7.20312C7.5 7.89348 7.74408 8.48274 8.23223 8.9709C8.72039 9.45905 9.30965 9.70312 10 9.70312C10.6904 9.70312 11.2796 9.45905 11.7678 8.9709C12.2559 8.48274 12.5 7.89348 12.5 7.20312C12.5 6.51277 12.2559 5.92351 11.7678 5.43535ZM9.29289 6.49602C9.48816 6.30076 9.72386 6.20312 10 6.20312C10.2761 6.20312 10.5118 6.30076 10.7071 6.49602C10.9024 6.69128 11 6.92698 11 7.20312C11 7.47927 10.9024 7.71497 10.7071 7.91023C10.5118 8.10549 10.2761 8.20312 10 8.20312C9.72386 8.20312 9.48816 8.10549 9.29289 7.91023C9.09763 7.71497 9 7.47927 9 7.20312C9 6.92698 9.09763 6.69128 9.29289 6.49602ZM5.99443 13.8593C5.99443 13.9007 5.99104 13.9418 5.98425 13.9825C5.97746 14.0233 5.96737 14.0633 5.95398 14.1023C5.94059 14.1415 5.92408 14.1792 5.90444 14.2156C5.88481 14.252 5.86232 14.2865 5.83699 14.3191C5.81165 14.3518 5.7838 14.3822 5.75344 14.4102C5.72308 14.4383 5.69062 14.4637 5.65607 14.4863C5.62152 14.509 5.58534 14.5287 5.54753 14.5454C5.50972 14.5621 5.4708 14.5756 5.43076 14.5858L5.42934 14.5862C4.51012 14.8221 3.80118 15.1077 3.30252 15.4429C2.93417 15.6905 2.75 15.9056 2.75 16.0881C2.75 16.2272 2.86797 16.3933 3.1039 16.5865C3.43977 16.8617 3.93468 17.1125 4.58864 17.339C6.07123 17.8526 7.87501 18.1093 10 18.1093C12.125 18.1093 13.9288 17.8526 15.4114 17.339C16.0653 17.1125 16.5602 16.8617 16.8961 16.5865C17.132 16.3933 17.25 16.2272 17.25 16.0881C17.25 15.911 17.0745 15.7018 16.7234 15.4605C16.2453 15.1319 15.5626 14.8496 14.6753 14.6135C14.6356 14.603 14.5971 14.5893 14.5596 14.5724C14.5222 14.5555 14.4864 14.5357 14.4522 14.5129C14.4181 14.4902 14.386 14.4648 14.356 14.4367C14.326 14.4087 14.2985 14.3784 14.2735 14.3458C14.2484 14.3133 14.2262 14.2789 14.2069 14.2427C14.1875 14.2065 14.1712 14.169 14.158 14.1301C14.1448 14.0913 14.1348 14.0516 14.1281 14.0111C14.1214 13.9706 14.1181 13.9298 14.1181 13.8887C14.1181 13.8395 14.1229 13.7908 14.1325 13.7424C14.1421 13.6942 14.1563 13.6473 14.1752 13.6017C14.194 13.5563 14.2171 13.5131 14.2445 13.4721C14.2718 13.4311 14.3029 13.3932 14.3377 13.3584C14.3726 13.3236 14.4105 13.2925 14.4514 13.2651C14.4923 13.2378 14.5356 13.2147 14.5811 13.1958C14.6266 13.177 14.6735 13.1628 14.7218 13.1531C14.7701 13.1435 14.8188 13.1387 14.8681 13.1387C14.9334 13.1387 14.9977 13.1471 15.0609 13.1639C16.1149 13.4443 16.9525 13.7979 17.573 14.2242C18.3577 14.7636 18.75 15.3849 18.75 16.0881C18.75 17.2093 17.8008 18.0987 15.9023 18.7563C14.2607 19.325 12.2933 19.6093 10 19.6093C7.70671 19.6094 5.73926 19.3251 4.09765 18.7563C2.19922 18.0987 1.25 17.2093 1.25 16.0881C1.25 15.3729 1.65521 14.7429 2.46564 14.198C3.10737 13.7666 3.97152 13.4116 5.0581 13.1329C5.11922 13.1172 5.18133 13.1093 5.24443 13.1093C5.29368 13.1093 5.34245 13.1142 5.39075 13.1238C5.43905 13.1334 5.48595 13.1476 5.53144 13.1664C5.57694 13.1853 5.62016 13.2084 5.66111 13.2357C5.70206 13.2631 5.73994 13.2942 5.77476 13.329C5.80958 13.3639 5.84067 13.4018 5.86803 13.4427C5.89539 13.4837 5.91849 13.5269 5.93734 13.5723C5.95619 13.6179 5.97041 13.6648 5.98002 13.713C5.98963 13.7614 5.99443 13.8101 5.99443 13.8593Z" fill="#3F68E0"/>
            </svg>
              <span class="address-text">${prediction.description}</span>
            `;

            item.addEventListener('click', () => {
              input.value = prediction.description;
              suggestionsContainer.style.display = 'none';

              // Get place details and update map
              placesService.getDetails({
                placeId: prediction.place_id,
                fields: ['geometry']
              }, (place, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                  this.map.setCenter(place.geometry.location);
                  this.map.setZoom(18);
                  new google.maps.Marker({
                    position: place.geometry.location,
                    map: this.map,
                    title: 'Selected Location'
                  });
                  this.container.querySelector('.next-btn').disabled = false;
                }
              });
            });

            suggestionsList.appendChild(item);
          });

          suggestionsContainer.style.display = 'block';
        });
      }, 300);
    });

    // Close suggestions when clicking outside
    document.addEventListener('click', (e) => {
      if (!input.contains(e.target) && !suggestionsContainer.contains(e.target)) {
        suggestionsContainer.style.display = 'none';
      }
    });
  }

  _initSteps() {
    const container = this.container;
    const nextBtns = container.querySelectorAll('.next-btn');
    const backBtns = container.querySelectorAll('.back-btn');

    nextBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (this.currentStep === 1) {
          // Step 1: Collect address and location data
          const addressInput = container.querySelector('#address-input');
          const mapElement = document.getElementById('map');
          const map = this.map;
          
          if (map && map.getCenter()) {
            const geocoder = new google.maps.Geocoder();
            const latlng = map.getCenter();
            
            geocoder.geocode({ location: latlng }, (results, status) => {
              if (status === 'OK' && results[0]) {
                // Get country from address components
                const addressComponents = results[0].address_components;
                const countryComponent = addressComponents.find(component => 
                  component.types.includes('country')
                );
                
                this.chooseForm.latitude = latlng.lat();
                this.chooseForm.longitude = latlng.lng();
                this.chooseForm.address = addressInput.value;
                this.chooseForm.country = countryComponent ? countryComponent.short_name.toLowerCase() : 'de';
              }
            });
          }

          container.querySelector('.step-1').style.display = 'none';
          container.querySelector('.step-2').style.display = 'block';
          container.querySelector('[data-step="2"]').classList.add('active');
          this.currentStep = 2;
        } else if (this.currentStep === 2) {
          // Step 2: Collect energy usage data
          const familySize = container.querySelector('.custom-select .select-value').dataset.value;
          const dayPercentage = container.querySelector('.day-value .percentage').textContent;
          // const monthlyBill = container.querySelector('.input-with-prefix input').value;
          // const avgPrice = container.querySelectorAll('.input-with-prefix input')[1].value;

          this.chooseForm.familyStructure = parseInt(familySize);
          this.chooseForm.daytimeElectrPercentage = parseInt(dayPercentage);
          // this.chooseForm.monthElectricPriceBefore = parseFloat(monthlyBill);
          // this.chooseForm.avgElectricPrice = parseFloat(avgPrice);

          container.querySelector('.step-2').style.display = 'none';
          container.querySelector('.step-3').style.display = 'block';
          container.querySelector('[data-step="3"]').classList.add('active');
          this.currentStep = 3;
        } else if (this.currentStep === 3) {
          // Step 3: Collect savings and installation preferences
          const savingsPercentage = container.querySelector('.savings-value').textContent;
          const installationOptions = container.querySelectorAll('.installation-option input:checked');
          const selectedPlaces = Array.from(installationOptions).map(option => parseInt(option.value));

          this.chooseForm.electricityPricePercentage = savingsPercentage.replace('%', '');
          this.chooseForm.solarPanelsPlace = selectedPlaces;

          // 状态UI元素
          const step3Content = container.querySelector('.step-3');
          const statusBox = container.querySelector('.step-3-status');
          const loadingBox = statusBox.querySelector('.status-loading');
          const successBox = statusBox.querySelector('.status-success');
          const errorBox = statusBox.querySelector('.status-error');

          // 隐藏表单内容，显示 loading
          step3Content.style.display = 'none';
          statusBox.style.display = 'block';
          loadingBox.style.display = 'block';
          successBox.style.display = 'none';
          errorBox.style.display = 'none';

          fetch('https://api-e.ecoflow.com/app/energy-diy/submit', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-appid': '7'
            },
            body: JSON.stringify(this.chooseForm)
          })
          .then(response => response.json())
          .then(data => {
            if (data && data.code == "0") {
              // 显示加载中
              // 获取diyId并请求方案
              const diyId = data.data && data.data.diyId;
              if (diyId) {
                fetch(`https://api-e.ecoflow.com/app/energy-diy/getDiyPlan?diyId=${diyId}`, {
                  method: 'GET',
                  headers: {
                    'x-appid': '7'
                  }
                })
                .then(resp => resp.json())
                .then(planData => {
                  // 填充推荐方案卡片
                  const card = successBox.querySelector('.diy-plan-card');
                  if (!planData || !planData.data || !Array.isArray(planData.data)) {
                    card.style.display = 'block';
                    card.innerHTML = '<div style="color:#F04438;">未获取到推荐方案</div>';
                    return;
                  }
                  this.bundles = planData.data;
                  planData.data.forEach((item,index) => {
                    const tab = card.querySelector('.plan-tab[data-index="'+item.bundleType+'"]');
                    tab.style.display = "block";
                    if(index == 0){
                      this.renderBundle(item.bundleType);
                    }
                  })
                  loadingBox.style.display = 'none';
                  successBox.style.display = 'block';
                  card.style.display = 'block';
                })
                .catch((e) => {

                  console.log("error", e);
                  // resultBox.innerHTML = '<span style="color:#F04438;">获取方案失败</span>';
                  loadingBox.style.display = 'none';
                  errorBox.style.display = 'block';
                });
              } else {
                // resultBox.innerHTML = '<span style="color:#F04438;">未获取到diyId</span>';
                loadingBox.style.display = 'none';
                errorBox.style.display = 'block';
              }
            } else {
              loadingBox.style.display = 'none';
              errorBox.style.display = 'block';
            }
          })
          .catch(error => {
            loadingBox.style.display = 'none';
            errorBox.style.display = 'block';
          });

          // 返回按钮事件（只绑定一次）
          statusBox.querySelectorAll('.back-btn').forEach(btn => {
            btn.onclick = () => {
              statusBox.style.display = 'none';
              step3Content.style.display = 'none';
              container.querySelector('.step-1').style.display = 'block';
              container.querySelector('.step-2').style.display = 'none';
              container.querySelector('.step-3').style.display = 'none';
              container.querySelector('[data-step="2"]').classList.remove('active');
              container.querySelector('[data-step="3"]').classList.remove('active');
              this.currentStep = 1;
              container.querySelector('.step.current').classList.remove('current');
              container.querySelectorAll('.step')[0].classList.add('current');
            }
          });
          return; // 阻止后续 current step class 切换
        }
        container.querySelector('.step.current').classList.remove("current");
        container.querySelectorAll('.step')[this.currentStep - 1].classList.add("current");
      });
    });

    backBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (this.currentStep === 2) {
          container.querySelector('.step-1').style.display = 'block';
          container.querySelector('.step-2').style.display = 'none';
          container.querySelector('[data-step="2"]').classList.remove('active');
          this.currentStep = 1;
        } else if (this.currentStep === 3) {
          container.querySelector('.step-2').style.display = 'block';
          container.querySelector('.step-3').style.display = 'none';
          container.querySelector('[data-step="3"]').classList.remove('active');
          this.currentStep = 2;
        }
        container.querySelector('.step.current').classList.remove("current");
        container.querySelectorAll('.step')[this.currentStep - 1].classList.add("current");
      });
    });

    // Initialize savings slider
    this._initSavingsSlider();

    // Privacy Policy 弹窗逻辑
    const privacyLink = container.querySelector('.privacy-policy a');
    const modal = container.querySelector('.privacy-modal');
    if (privacyLink && modal) {
      privacyLink.addEventListener('click', e => {
        e.preventDefault();
        modal.style.display = 'flex';
      });
      modal.querySelector('.privacy-modal__close').onclick = () => {
        modal.style.display = 'none';
      };
      modal.querySelector('.privacy-modal__mask').onclick = () => {
        modal.style.display = 'none';
      };
    }
  }

  _initSavingsSlider() {
    const slider = this.container.querySelector('.savings-slider');
    if (!slider) return;

    const handle = slider.querySelector('.slider-handle');
    const progress = slider.querySelector('.savings-progress');
    const value = slider.querySelector('.savings-value');
    let isDragging = false;
    let startX, startLeft;

    const updateSlider = (clientX) => {
      const rect = slider.getBoundingClientRect();
      let newLeft = ((clientX - rect.left) / rect.width) * 100;
      newLeft = Math.max(0, Math.min(100, newLeft));
      
      handle.style.left = `${newLeft}%`;
      progress.style.width = `${newLeft}%`;
      value.textContent = `${Math.round(newLeft)}%`;
      value.style.left = `${newLeft}%`;
    };

    handle.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.clientX;
      startLeft = parseFloat(handle.style.left);
      handle.style.cursor = 'grabbing';
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      updateSlider(e.clientX);
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
      handle.style.cursor = 'grab';
    });

    // Touch events for mobile
    handle.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].clientX;
      startLeft = parseFloat(handle.style.left);
    });

    document.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      updateSlider(e.touches[0].clientX);
    });

    document.addEventListener('touchend', () => {
      isDragging = false;
    });
  }

  _initCustomSelect() {
    const select = this.container.querySelector('.custom-select');
    const value = select.querySelector('.select-value');
    const options = select.querySelector('.select-options');
    const optionItems = select.querySelectorAll('.select-option');

    select.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = options.style.display === 'block';
      options.style.display = isOpen ? 'none' : 'block';
      select.classList.toggle('open', !isOpen);
    });

    optionItems.forEach(option => {
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        value.textContent = option.textContent;
        value.dataset.value = option.dataset.value
        options.style.display = 'none';
        select.classList.remove('open');
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!select.contains(e.target)) {
        options.style.display = 'none';
        select.classList.remove('open');
      }
    });
  }

  _initUsageSlider() {
    const slider = this.container.querySelector('.usage-slider');
    const handle = slider.querySelector('.slider-handle');
    const dayValue = slider.querySelector('.day-value .percentage');
    const nightValue = slider.querySelector('.night-value .percentage');
    const dayBg = slider.querySelector('.day-bg');
    const nightBg = slider.querySelector('.night-bg');
    let isDragging = false;
    let startX, startLeft;

    const updateSlider = (clientX) => {
      const rect = slider.getBoundingClientRect();
      let newLeft = ((clientX - rect.left) / rect.width) * 100;
      newLeft = Math.max(0, Math.min(100, newLeft));
      
      handle.style.left = `${newLeft}%`;
      dayValue.textContent = `${Math.round(newLeft)}%`;
      nightValue.textContent = `${Math.round(100 - newLeft)}%`;
      
      // Update background widths
      dayBg.style.width = `${newLeft}%`;
      nightBg.style.width = `${100 - newLeft}%`;
    };

    handle.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.clientX;
      startLeft = parseFloat(handle.style.left);
      handle.style.cursor = 'grabbing';
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      updateSlider(e.clientX);
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
      handle.style.cursor = 'grab';
    });

    // Touch events for mobile
    handle.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].clientX;
      startLeft = parseFloat(handle.style.left);
    });

    document.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      updateSlider(e.touches[0].clientX);
    });

    document.addEventListener('touchend', () => {
      isDragging = false;
    });

  }

  _initPlanTabs() {
    const card = this.container.querySelector('.diy-plan-card');
    if (!card) return;

    const tabs = card.querySelectorAll('.plan-tab');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const idx = parseInt(tab.getAttribute('data-index'));
        this.currentIndex = idx;
        this.renderBundle(idx);
      });
    });


    const backBtn = card.querySelector('.plan-reselect');
    backBtn.addEventListener('click', () => {
      this._resetSteps(); 
    });
  }

  renderBundle(idx) {
    const card = this.container.querySelector('.diy-plan-card');
    if (!card) return;

    const bundle = this.bundles[idx];
    if (!bundle) return;

    // Update tab states
    card.querySelectorAll('.plan-tab').forEach((tab, index) => {
      tab.classList.toggle('active', index === idx);
    });

    this.savePerYear.innerHTML = bundle.reducePriceYearly + " " + this.currencySymbol;
    this.capacity.innerHTML = bundle.energyStorage;
    this.electricityGenerated.innerHTML = bundle.powerGenerationYearly;
// productPics
    const bundleGallery = this.container.querySelector('.bundle-gallery');
    const mainGallery = this.container.querySelector('.product-single__media__carousel');
    const thumbnails = this.container.querySelector('.thumbnails-grid');
    if (bundleGallery && bundle.productPics && bundle.productPics.length) {
      this._renderBundleGallery(bundle.productPics);
      bundleGallery.style.display = 'block';
      if (mainGallery) mainGallery.style.display = 'none';
      if (thumbnails) thumbnails.style.display = 'none';
    }
// bundleType 0 最节省 bundleType 1 最推荐
    this.container.querySelector('#plan-save-amount').innerHTML = this.currencySymbol +" " + bundle.reducePriceYearly;
    this.container.querySelectorAll("#plan-env .percentage-num").forEach(item => {
      if(bundle.environmentalProtection > 100){
        item.innerHTML = "100%";
        card.querySelector('.plan-env .after-env').style.setProperty('--env-width',"0%");
      }else{
        item.innerHTML = bundle.environmentalProtection + "%";
        card.querySelector('.plan-env .after-env').style.setProperty('--env-width',(100 - bundle.environmentalProtection) + "%");
      }
    });

    this.container.querySelector('#plan-bill .bill-before .bill-label span').innerHTML =  this.currencySymbol + bundle.electricPriceMonthly;

    this.container.querySelector('#plan-bill .bill-after .bill-label span').innerHTML =  this.currencySymbol + bundle.electricPriceMonthlyAfter;

    // Update environmental contribution
    const envBadge = card.querySelector('.env-badge span');
    if (envBadge) {
      envBadge.innerHTML = bundle.envPercent + '%';
    }
    
    // Update bill information
    const billBefore = card.querySelector('.bill-before .bill-label span');
    const billAfter = card.querySelector('.bill-after .bill-label span');
    if (billBefore) billBefore.innerHTML =  bundle.electricPriceMonthly;
    if (billAfter) billAfter.innerHTML = bundle.electricPriceMonthlyAfter;
    
    // Update progress bar width
    const billAfterBar = card.querySelector('.bill-after .bar');
    const percentage = Math.round((parseInt(bundle.electricPriceMonthlyAfter) / parseInt(bundle.electricPriceMonthly)) * 100);
    if (billAfterBar) {
      billAfterBar.style.transform = "translateX(calc("+percentage+"% - 100%))";
    }

    this.container.querySelector('#plan-bill .percentage .num').innerHTML = (100 - percentage) + "%";

    this.container.querySelector('#solar-panel-power').innerHTML = bundle.solarPanelPower + " W";
    this.container.querySelector('#power-generation-yearly').innerHTML = bundle.powerGenerationYearly + " W";
    this.container.querySelector('#energy-storage').innerHTML = bundle.energyStorage.replace(/(\d)([a-zA-Z]+)/g, '$1 $2');
    this.container.querySelector('#output-power').innerHTML = bundle.outputPower.replace(/(\d)([a-zA-Z]+)/g, '$1 $2');
    this.container.querySelector('#offline-power').innerHTML = bundle.offlinePower.replace(/(\d)([a-zA-Z]+)/g, '$1 $2');
    this.container.querySelector('#bypass-power').innerHTML = bundle.bypassPower.replace(/(\d)([a-zA-Z]+)/g, '$1 $2');

    this.container.querySelector('.bundle-buy-container .price__sale .price-item--sale').innerHTML = bundle.price +""+ this.currencySymbol;
    this.container.querySelector('.bundle-buy-container .price__sale .price-item--regular').innerHTML = bundle.compareAtPrice + ""+ this.currencySymbol;

    this.container.querySelector('#product-form__cart-submit').href = bundle.productOrderUrl;


    var priceFormat = theme.priceCurrencyCodeEnable ? theme.moneyFormatWithCurrency : theme.moneyFormat;
    var comparePriceFormat = theme.comparePriceCurrencyCodeEnable ? theme.moneyFormatWithCurrency : theme.moneyFormat;
    var formatRegularPrice = function(regularPriceElement, price) {
      regularPriceElement.innerHTML = theme.Currency.formatMoney(
        price,
        comparePriceFormat
      ).replace(/\./g, ' ');
    };


    // const optionLabelIncluded = this.container.querySelector('.bundle-buy-container [data-tax-included]')
    // const optionLabelExcluded = this.container.querySelector('.bundle-buy-container [data-tax-excluded]')
    // if(variant.title.replace(/\s/g, '').includes("0%")){
    //   optionLabelIncluded.classList.add('hide')
    //   optionLabelExcluded.classList.remove('hide')
    // }else{
    //   optionLabelIncluded.classList.remove('hide')
    //   optionLabelExcluded.classList.add('hide')
    // }

    const klarnaEle = this.container.querySelector(".bundle-buy-container .product-klarna");
    const klarnaItem = klarnaEle.querySelector("klarna-placement");
    if(klarnaItem){
      klarnaItem.setAttribute("data-purchase-amount", bundle.price*100.0);
      if(window.Klarna && window.Klarna.OnsiteMessaging){
        window.Klarna.OnsiteMessaging.refresh();
      }
      if(klarnaEle && klarnaEle.dataset.info){
          klarnaEle.querySelector(".info").innerHTML = klarnaEle.dataset.info.replace("\${price}",theme.Currency.formatMoney(
          bundle.price*100.0/3.0,
          comparePriceFormat
        ).replace(/\./g, ' '));
      }
    }

  }

  _renderBundleGallery(pics) {
    const gallery = this.container.querySelector('.bundle-gallery');
    if (!gallery) return;

    // 清空旧内容
    gallery.innerHTML = '';

    // 构建 Flickity 结构
    const carousel = document.createElement('div');
    carousel.className = 'bundle-flickity-carousel';
    pics.forEach(url => {
      const cell = document.createElement('div');
      cell.className = 'carousel-cell';
      cell.innerHTML = `<img src="${url}" alt="bundle image" />`;
      carousel.appendChild(cell);
    });
    gallery.appendChild(carousel);

    // 销毁旧实例
    if (gallery.flickityInstance) {
      gallery.flickityInstance.destroy();
    }
    gallery.flickityInstance = new Flickity(carousel, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: true,
      wrapAround: true,
      imagesLoaded: true
    });
  }

  _initFormContent() {
    const container = this.container;
    
    // Initialize step 2 content
    const familySizeSelect = container.querySelector('.custom-select .select-value');
    if (familySizeSelect) {
      familySizeSelect.dataset.value = this.chooseForm.familyStructure;
    }

    const dayPercentage = container.querySelector('.day-value .percentage');
    if (dayPercentage) {
      dayPercentage.textContent = `${this.chooseForm.daytimeElectrPercentage}%`;
    }

    // const monthlyBillInput = container.querySelector('.input-with-prefix input');
    // if (monthlyBillInput) {
    //   monthlyBillInput.value = this.chooseForm.monthElectricPriceBefore;
    // }

    // const avgPriceInput = container.querySelectorAll('.input-with-prefix input')[1];
    // if (avgPriceInput) {
    //   avgPriceInput.value = this.chooseForm.avgElectricPrice;
    // }

    // Initialize step 3 content
    const savingsSlider = container.querySelector('.savings-slider');
    if (savingsSlider) {
      const savingsProgress = savingsSlider.querySelector('.savings-progress');
      const savingsHandle = savingsSlider.querySelector('.slider-handle');
      const savingsValue = savingsSlider.querySelector('.savings-value');
      
      if (savingsProgress && savingsHandle && savingsValue) {
        savingsProgress.style.width = `${this.chooseForm.electricityPricePercentage}%`;
        savingsHandle.style.left = `${this.chooseForm.electricityPricePercentage}%`;
        savingsValue.textContent = `${this.chooseForm.electricityPricePercentage}%`;
      }
    }

    // Initialize installation options
    const installationOptions = container.querySelectorAll('.installation-option input');
    if (installationOptions) {
      installationOptions.forEach(option => {
        const value = parseInt(option.value);
        option.checked = this.chooseForm.solarPanelsPlace.includes(value);
      });
    }
  }
};
if (!window.customElements.get("powerstream-v2")) {
  window.customElements.define("powerstream-v2", PowerstreamV2);
}
